import { CREATE_BULK_FILES_SUCCESS } from 'modules/campaignFiles/actionTypes';
import * as types from 'modules/campaigns/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<import("../types").Campaign>} CampaignDataEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<import('../types').Campaign>} */
const campaignAdapter = createEntityAdapter({ selectId: ({ id }) => id });

/**
 * @param {CampaignDataEntity} state
 * @param {import('modules/global/generic.types').PageContent<import('../types').Campaign>} action
 * @returns {CampaignDataEntity}
 */
const addManyFromPage = (state, { payload: { content } }) => campaignAdapter.updateMany(state, content);

const followUnfollowCampaign = (state, { payload: campaignId }) =>
  campaignAdapter.updateOne(state, { id: campaignId, followingBulkInProgress: true });

const updateFromUnschedule = (state, { payload: campaign }) =>
  campaignAdapter.updateOne(state, { ...campaign, sendDate: undefined });

const generateFiles = (state, { payload: { campaignId } }) =>
  campaignAdapter.updateOne(state, { id: campaignId, interventionsBulkInProgress: true });

export default createReducer(campaignAdapter.getInitialState(), {
  [types.FETCH_CAMPAIGNS_SUCCESS]: addManyFromPage,
  [types.FETCH_CAMPAIGN_SUCCESS]: campaignAdapter.addOne,
  [types.CREATE_CAMPAIGN_SUCCESS]: campaignAdapter.addOne,
  [types.DUPLICATE_CAMPAIGN_SUCCESS]: campaignAdapter.addOne,
  [types.SEND_CAMPAIGN_SUCCESS]: campaignAdapter.updateOne,
  [types.UPDATE_CAMPAIGN_SUCCESS]: campaignAdapter.addOne,
  [types.PATCH_CAMPAIGN_NAME_SUCCESS]: campaignAdapter.updateOne,
  [types.PATCH_CAMPAIGN_STATUS_SUCCESS]: campaignAdapter.updateOne,
  [types.PATCH_CAMPAIGN_SEND_DATE_SUCCESS]: campaignAdapter.updateOne,
  [types.DELETE_CAMPAIGN_SEND_DATE_SUCCESS]: updateFromUnschedule,
  [types.DELETE_CAMPAIGN_SUCCESS]: campaignAdapter.removeOne,
  [types.FOLLOW_CAMPAIGN_SUCCESS]: followUnfollowCampaign,
  [types.UNFOLLOW_CAMPAIGN_SUCCESS]: followUnfollowCampaign,
  [CREATE_BULK_FILES_SUCCESS]: generateFiles,
});
